import "../../global.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "react-toastify/dist/ReactToastify.css";
import AccessControl from "./AcessControl";

export const queryClient = new QueryClient();

const ClientAccessControl = ({
  children,
  allowedPermissions,
  renderNoAccess,
}: any) => {
  return (
    <QueryClientProvider client={queryClient}>
      <AccessControl
        children={children}
        allowedPermissions={allowedPermissions}
        renderNoAccess={renderNoAccess}
      />
    </QueryClientProvider>
  );
};

export default ClientAccessControl;
